// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Series Ids */
#drawerHoverAnim_L_Series1 {
    position: absolute;

    top: 0%;
    /* left: 42%; */

    width: 100%;
    height: 8.75%;

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

#drawerHoverAnim_R_Series1 {
    position: absolute;

    top: 0%;
    /* left: 29.7%; */

    width: 100%;
    height: 8.75%;

    transform: rotate(180deg);

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

.drawerHoverAnim_L_Series1_Closed{
    left: 42.2%;
}

.drawerHoverAnim_L_Series1_Opened {
    left: 39.4%;
}

.drawerHoverAnim_R_Series1_Closed{
    left: 30.35%;
}

.drawerHoverAnim_R_Series1_Opened {
    left: 32.8%;
}

#drawerHoverAnim_L_Series2 {
    position: absolute;

    top: 0%;

    width: 100%;
    height: 8.75%;

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

#drawerHoverAnim_R_Series2 {
    position: absolute;

    top: 0%;

    width: 100%;
    height: 8.75%;

    transform: rotate(180deg);

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

.drawerHoverAnim_L_Series2_Closed{
    left: 30.4%;
}

.drawerHoverAnim_L_Series2_Opened {
    left: 30.4%;
}

.drawerHoverAnim_R_Series2_Closed{
    left: 17.7%;
}

.drawerHoverAnim_R_Series2_Opened {
    left: 17.7%;
}

#drawerHoverAnim_L_Series3 {
    position: absolute;

    top: 0%;

    width: 100%;
    height: 8.75%;

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

#drawerHoverAnim_R_Series3 {
    position: absolute;

    top: 0%;

    width: 100%;
    height: 8.75%;

    transform: rotate(180deg);

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

.drawerHoverAnim_L_Series3_Closed{
    left: 25.8%;
}

.drawerHoverAnim_L_Series3_Opened {
    left: 28.4%;
}

.drawerHoverAnim_R_Series3_Closed{
    left: 25.8%;
}

.drawerHoverAnim_R_Series3_Opened {
    left: 23.6%;
}

/* Package Ids */

#drawerHoverAnim_L_Package1 {
    position: absolute;

    top: 0%;
    left: 17%;

    width: 100%;
    height: 8.75%;

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

#drawerHoverAnim_R_Package1 {
    position: absolute;

    top: 0%;
    left: -2.6%;

    width: 100%;
    height: 8.75%;

    transform: rotate(180deg);

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

#drawerHoverAnim_L_Package2 {
    position: absolute;

    top: 0%;

    width: 100%;
    height: 8.75%;

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

#drawerHoverAnim_R_Package2 {
    position: absolute;

    top: 0%;

    width: 100%;
    height: 8.75%;

    transform: rotate(180deg);

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

.drawerHoverAnim_L_Package2_Closed{
    left: 29.6%;
}

.drawerHoverAnim_L_Package2_Opened {
    left: 29.3%;
}

.drawerHoverAnim_R_Package2_Closed{
    left: 19%;
}

.drawerHoverAnim_R_Package2_Opened {
    left: 19.2%;
}

#drawerHoverAnim_L_Package3 {
    position: absolute;

    top: 0%;

    width: 100%;
    height: 8.75%;

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

#drawerHoverAnim_R_Package3 {
    position: absolute;

    top: 0%;

    width: 100%;
    height: 8.75%;

    transform: rotate(180deg);

    object-fit: contain;

    transition: left 0.2s ease-in-out;
}

.drawerHoverAnim_L_Package3_Closed{
    left: 14.7%;
}

.drawerHoverAnim_L_Package3_Opened {
    left: 17.6%;
}

.drawerHoverAnim_R_Package3_Closed{
    left: 5.2%;
}

.drawerHoverAnim_R_Package3_Opened {
    left: 3.5%;
}

/* The other pieces */

.AnimArrow1 {
    position: absolute;

    height:100%;

    left: -9%;
}

.AnimArrow2 {
    position: absolute;

    height:100%;

    left: -12%;
}

.AnimArrow3 {
    position: absolute;

    height:100%;
    
    left: -15.6%;
}

.animIn1 {
    animation: AnimIn-Arrow1 0.1s 0s forwards;
    animation-timing-function: ease;
}

.animOut1 {
    animation: AnimOut-Arrow1 0.6s 0s forwards;   
    animation-timing-function: ease-in;
}

.animIn2 {
    animation: AnimIn-Arrow2 0.4s 0s forwards;
    animation-timing-function: ease;
}

.animOut2 {
    animation: AnimOut-Arrow2 0.4s 0s forwards; 
    animation-timing-function: ease-in;
}

.animIn3 {
    animation: AnimIn-Arrow3 0.7s 0s forwards;
    animation-timing-function: ease;
}

.animOut3 {
    animation: AnimOut-Arrow3 0.2s 0s forwards; 
    animation-timing-function: ease-in; 
}

@keyframes AnimIn-Arrow1 {
    from {
        left: -9%;
    }
    to {
        left: 0%;
    }
}

@keyframes AnimOut-Arrow1 {
    from {
        left: 0%;
    }
    66% {
        left: 0%;
    }
    to {
        left: -9%;
    }
}

@keyframes AnimIn-Arrow2 {
    from {
        left: -12%;
    }
    10% {
        left: -12%;
    }
    to {
        left: 0%;
    }
}

@keyframes AnimOut-Arrow2 {
    from {
        left: 0%;
    }
    50% {
        left: 0%;
    }
    to {
        left: -12%;
    }
}

@keyframes AnimIn-Arrow3 {
    from {
        left: -15.6%;
    }
    30% {
        left: -15.6%;
    }
    to {
        left: 0%;
    }
}

@keyframes AnimOut-Arrow3 {
    from {
        left: 0%;
    }
    to {
        left: -15.6%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DrawerHoverAnim.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,kBAAkB;;IAElB,OAAO;IACP,eAAe;;IAEf,WAAW;IACX,aAAa;;IAEb,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;;IAElB,OAAO;IACP,iBAAiB;;IAEjB,WAAW;IACX,aAAa;;IAEb,yBAAyB;;IAEzB,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,OAAO;;IAEP,WAAW;IACX,aAAa;;IAEb,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;;IAElB,OAAO;;IAEP,WAAW;IACX,aAAa;;IAEb,yBAAyB;;IAEzB,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,OAAO;;IAEP,WAAW;IACX,aAAa;;IAEb,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;;IAElB,OAAO;;IAEP,WAAW;IACX,aAAa;;IAEb,yBAAyB;;IAEzB,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,gBAAgB;;AAEhB;IACI,kBAAkB;;IAElB,OAAO;IACP,SAAS;;IAET,WAAW;IACX,aAAa;;IAEb,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;;IAElB,OAAO;IACP,WAAW;;IAEX,WAAW;IACX,aAAa;;IAEb,yBAAyB;;IAEzB,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;;IAElB,OAAO;;IAEP,WAAW;IACX,aAAa;;IAEb,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;;IAElB,OAAO;;IAEP,WAAW;IACX,aAAa;;IAEb,yBAAyB;;IAEzB,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;;IAElB,OAAO;;IAEP,WAAW;IACX,aAAa;;IAEb,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;;IAElB,OAAO;;IAEP,WAAW;IACX,aAAa;;IAEb,yBAAyB;;IAEzB,mBAAmB;;IAEnB,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;;AAErB;IACI,kBAAkB;;IAElB,WAAW;;IAEX,SAAS;AACb;;AAEA;IACI,kBAAkB;;IAElB,WAAW;;IAEX,UAAU;AACd;;AAEA;IACI,kBAAkB;;IAElB,WAAW;;IAEX,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":["/* Series Ids */\r\n#drawerHoverAnim_L_Series1 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n    /* left: 42%; */\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHoverAnim_R_Series1 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n    /* left: 29.7%; */\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    transform: rotate(180deg);\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n.drawerHoverAnim_L_Series1_Closed{\r\n    left: 42.2%;\r\n}\r\n\r\n.drawerHoverAnim_L_Series1_Opened {\r\n    left: 39.4%;\r\n}\r\n\r\n.drawerHoverAnim_R_Series1_Closed{\r\n    left: 30.35%;\r\n}\r\n\r\n.drawerHoverAnim_R_Series1_Opened {\r\n    left: 32.8%;\r\n}\r\n\r\n#drawerHoverAnim_L_Series2 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHoverAnim_R_Series2 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    transform: rotate(180deg);\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n.drawerHoverAnim_L_Series2_Closed{\r\n    left: 30.4%;\r\n}\r\n\r\n.drawerHoverAnim_L_Series2_Opened {\r\n    left: 30.4%;\r\n}\r\n\r\n.drawerHoverAnim_R_Series2_Closed{\r\n    left: 17.7%;\r\n}\r\n\r\n.drawerHoverAnim_R_Series2_Opened {\r\n    left: 17.7%;\r\n}\r\n\r\n#drawerHoverAnim_L_Series3 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHoverAnim_R_Series3 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    transform: rotate(180deg);\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n.drawerHoverAnim_L_Series3_Closed{\r\n    left: 25.8%;\r\n}\r\n\r\n.drawerHoverAnim_L_Series3_Opened {\r\n    left: 28.4%;\r\n}\r\n\r\n.drawerHoverAnim_R_Series3_Closed{\r\n    left: 25.8%;\r\n}\r\n\r\n.drawerHoverAnim_R_Series3_Opened {\r\n    left: 23.6%;\r\n}\r\n\r\n/* Package Ids */\r\n\r\n#drawerHoverAnim_L_Package1 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n    left: 17%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHoverAnim_R_Package1 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n    left: -2.6%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    transform: rotate(180deg);\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHoverAnim_L_Package2 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHoverAnim_R_Package2 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    transform: rotate(180deg);\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n.drawerHoverAnim_L_Package2_Closed{\r\n    left: 29.6%;\r\n}\r\n\r\n.drawerHoverAnim_L_Package2_Opened {\r\n    left: 29.3%;\r\n}\r\n\r\n.drawerHoverAnim_R_Package2_Closed{\r\n    left: 19%;\r\n}\r\n\r\n.drawerHoverAnim_R_Package2_Opened {\r\n    left: 19.2%;\r\n}\r\n\r\n#drawerHoverAnim_L_Package3 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n#drawerHoverAnim_R_Package3 {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n\r\n    width: 100%;\r\n    height: 8.75%;\r\n\r\n    transform: rotate(180deg);\r\n\r\n    object-fit: contain;\r\n\r\n    transition: left 0.2s ease-in-out;\r\n}\r\n\r\n.drawerHoverAnim_L_Package3_Closed{\r\n    left: 14.7%;\r\n}\r\n\r\n.drawerHoverAnim_L_Package3_Opened {\r\n    left: 17.6%;\r\n}\r\n\r\n.drawerHoverAnim_R_Package3_Closed{\r\n    left: 5.2%;\r\n}\r\n\r\n.drawerHoverAnim_R_Package3_Opened {\r\n    left: 3.5%;\r\n}\r\n\r\n/* The other pieces */\r\n\r\n.AnimArrow1 {\r\n    position: absolute;\r\n\r\n    height:100%;\r\n\r\n    left: -9%;\r\n}\r\n\r\n.AnimArrow2 {\r\n    position: absolute;\r\n\r\n    height:100%;\r\n\r\n    left: -12%;\r\n}\r\n\r\n.AnimArrow3 {\r\n    position: absolute;\r\n\r\n    height:100%;\r\n    \r\n    left: -15.6%;\r\n}\r\n\r\n.animIn1 {\r\n    animation: AnimIn-Arrow1 0.1s 0s forwards;\r\n    animation-timing-function: ease;\r\n}\r\n\r\n.animOut1 {\r\n    animation: AnimOut-Arrow1 0.6s 0s forwards;   \r\n    animation-timing-function: ease-in;\r\n}\r\n\r\n.animIn2 {\r\n    animation: AnimIn-Arrow2 0.4s 0s forwards;\r\n    animation-timing-function: ease;\r\n}\r\n\r\n.animOut2 {\r\n    animation: AnimOut-Arrow2 0.4s 0s forwards; \r\n    animation-timing-function: ease-in;\r\n}\r\n\r\n.animIn3 {\r\n    animation: AnimIn-Arrow3 0.7s 0s forwards;\r\n    animation-timing-function: ease;\r\n}\r\n\r\n.animOut3 {\r\n    animation: AnimOut-Arrow3 0.2s 0s forwards; \r\n    animation-timing-function: ease-in; \r\n}\r\n\r\n@keyframes AnimIn-Arrow1 {\r\n    from {\r\n        left: -9%;\r\n    }\r\n    to {\r\n        left: 0%;\r\n    }\r\n}\r\n\r\n@keyframes AnimOut-Arrow1 {\r\n    from {\r\n        left: 0%;\r\n    }\r\n    66% {\r\n        left: 0%;\r\n    }\r\n    to {\r\n        left: -9%;\r\n    }\r\n}\r\n\r\n@keyframes AnimIn-Arrow2 {\r\n    from {\r\n        left: -12%;\r\n    }\r\n    10% {\r\n        left: -12%;\r\n    }\r\n    to {\r\n        left: 0%;\r\n    }\r\n}\r\n\r\n@keyframes AnimOut-Arrow2 {\r\n    from {\r\n        left: 0%;\r\n    }\r\n    50% {\r\n        left: 0%;\r\n    }\r\n    to {\r\n        left: -12%;\r\n    }\r\n}\r\n\r\n@keyframes AnimIn-Arrow3 {\r\n    from {\r\n        left: -15.6%;\r\n    }\r\n    30% {\r\n        left: -15.6%;\r\n    }\r\n    to {\r\n        left: 0%;\r\n    }\r\n}\r\n\r\n@keyframes AnimOut-Arrow3 {\r\n    from {\r\n        left: 0%;\r\n    }\r\n    to {\r\n        left: -15.6%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
